import styled from 'styled-components'

// Components
import { MemberCard } from '../../../MemberCard'

export const Wrapper = styled.li`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding: 16px;
  border-radius: ${({ theme }) => theme.radii.large};

  :nth-child(2n + 1) {
    background-color: ${({ theme }) => theme.colors.background.secondary[2]};
  }
`
export const StyledMemberCard = styled(MemberCard)`
  overflow: hidden;
  /* Fix the MemberCard avatar margin-left */
  margin-left: 0;
  margin-right: 20px;
  flex-grow: 1;
`
